import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BottomSheet } from "react-spring-bottom-sheet";
import { sheetOpen, sheetClose } from "../../redux/bottomSheetSlice";
import { Link } from 'react-router-dom';
import SectionTitle from '../sectionTitle/SectionTitle';
import close from "../../assets/images/close.svg";
import empty from "../../assets/images/empty.svg" 
import { fetchCustomerOrder } from '../../services/customerOrder';
import { returnAttributes } from '../../services/returnAttributes';
import { returnRequest } from '../../services/returnRequest';
import "./OrderDetails.scss";
import {setReturnResponse} from "../../redux/returnRequestSlice";
import { toast } from 'react-toastify';

const OrderDetails = () => {
  const dispatch = useDispatch();
  const isSheetOpen = useSelector((state) => state.bottomSheet.isSheetOpen);
  const isSheetId = useSelector((state) => state.bottomSheet.isSheetId);
  const { token } = useSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState(0);
  const [allOrder, setAllOrder] = useState([]);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({
    itemId: null,
    entityId: null
  });
  const [returnReson, setReturnReson] = useState([]);
  const [returnDataValue, setReturnDataValue] = useState();
  const [selectedReasonLabel, setSelectedReasonLabel] = useState("");
  const [selectedReasonValue, setSelectedReasonValue] = useState("");
  const [detailOptions, setDetailOptions] = useState([]);
  const [attributeCode, setAttributeCode] = useState("");
  const [submitStart, setSubmitStart] = useState(false);
  const [viewItem, setViewItem]   = useState(null);
  const decodedOrderItemIds = useSelector((state) => state.returnRequest.decodedOrderItemIds);
  const {tempReturn} = useSelector((state) => state.returnRequest);
  const [isBuyback, setIsbuyback] = useState(false);
  const [isBuybackLabel, setIsbuybackLabel] = useState("");


  const getSalesOrderData = async () => {
    try {
      setLoadingOrder(true);
      const result = await fetchCustomerOrder(token);

      const salesData = result?.data?.salesOrder?.salesData;
      if (salesData) {
        setAllOrder(salesData);
      } else {
        console.warn('No sales data found.');
      }
    } catch (error) {
      console.error('Error fetching sales order data:', error);
    } finally {
      setLoadingOrder(false);
    }
  };

  useEffect(() => {
    getSalesOrderData();
  }, []);  

  console.log(allOrder);
  console.log("tempReturn");
  console.log(tempReturn);

  const filteredOrders = allOrder.filter(order => {
    switch (activeTab) {
      case 1: return order.totals.status === "Pending";
      case 2: return order.totals.status === "Canceled";
      case 3: return order.totals.status === "Payment Confirmed";
      default: return true;
    }
  });

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const returnAttributesData = async () => {    
    const result = await returnAttributes();
    console.log("returnAttributesData");
    if (result) {
      setReturnReson(result.data.getReturnAttributes);
    } else {
      console.warn('No data found');
    }
  };

  const handleReturnOrder = (itemId, entityId) => {
    setSelectedOrder({ itemId, entityId });
    returnAttributesData();
    dispatch(sheetOpen("returnOrderSheet"));
    console.log(itemId, entityId);
  }

  useEffect(() => {    
    if(returnReson){
      const returnData = returnReson.find(item => item.attribute_code === "reason_for_return");
      setReturnDataValue(returnData);      
    }
  }, [returnReson]);
 
  const handleReasonChange = (e) => {
    const selectedOptionId = e.target.value;

    const selected = returnDataValue?.values.find(
      (item) => item.option_id === selectedOptionId
    ); 

    const selectedLabel = selected.label;
    const isBuyBackValue = selectedLabel === "Buy Back";

    if(isBuyBackValue){
      setIsbuyback(true);
      setIsbuybackLabel(selectedOptionId);
    }else{
      setIsbuyback(false);
      const matchedDetail = returnReson.find(
        (item) =>
          item.label?.toLowerCase().includes(selected?.label?.toLowerCase()) &&
          item.attribute_code !== "reason_for_return"
      ); 
      setDetailOptions(matchedDetail?.values || []);
      setAttributeCode(matchedDetail.attribute_code);
    }

    
  };

  const handleReasonChangeValue = (e)=>{
    const selectedOptionId = e.target.value;
    const selected = detailOptions?.find(
      (item) => item.option_id === selectedOptionId
    );  
    setSelectedReasonValue(selected?.option_id || "");
    setSelectedReasonLabel(selected?.attribute_code || "");    
  }

  const submitReturnRequest =  async () => {  
    try {
      setSubmitStart(true);      
      let orderId = selectedOrder.entityId;
      let orderItemId = selectedOrder.itemId;
      let selectedAttributeCode = attributeCode;
      let selectedOptionId =  selectedReasonValue;     

      if (isBuyback) {
        const result = await returnRequest({
          token,
          orderId,
          orderItemId,
          selectedCustomAttributes: [
            {
              attribute_code: "reason_for_return",
              value: isBuybackLabel,
            },
          ],
        });
        dispatch(setReturnResponse(result));
        dispatch(sheetClose());
        setSubmitStart(false);
        return; 
      }

      if (!selectedAttributeCode || !selectedOptionId) {
        toast.error("Please Select Reason", {
            theme: "colored",
            autoClose: 1500,
        });
        setSubmitStart(false);
        return;
      }

      const selectedCustomAttributes = [
        {
          attribute_code: "reason_for_return",
          value: selectedReasonValue, 
        },
        {
          attribute_code: selectedAttributeCode, 
          value: selectedOptionId,  
        },
      ];
      const result = await returnRequest({
        token,
        orderId,
        orderItemId,
        selectedCustomAttributes,
      });
  
      dispatch(setReturnResponse(result));
      dispatch(sheetClose());
      setSubmitStart(false);  
      
      setAttributeCode("");
      setSelectedReasonValue("");

    } catch (error) {
      console.error('Error fetching sales order data:', error);
      setSubmitStart(false);
    } 
  }

  const viewOrderDetails = (itemId)=>{  
    const singleOrder = allOrder.find(order =>
      order.items.some(item => item.item_id === itemId)
    );    
    const matchedItem = singleOrder?.items.find(item => item.item_id === itemId);  
    if (matchedItem) {
      try {
        if (typeof matchedItem.product_options === "string") {
          matchedItem.product_options = JSON.parse(matchedItem.product_options);
        }
      } catch (error) {
        console.error("Error parsing product_options", error);
        matchedItem.product_options = {};
      }  
      setViewItem(matchedItem);
      dispatch(sheetOpen("viewOrderDetails"));
    }
  }

  

  const orderTabs = ["All", "Open", "Cancelled", "Completed"];
  
  return (
    <>
      <div className='order--tab'>
        {orderTabs.map((tab, index) => (
          <button
            key={index}
            className={`order--tab-button ${activeTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className='order'>
        {loadingOrder ? (
            <p>Loading orders...</p>
          ) : 
          allOrder.length > 0 ? (         
            filteredOrders && filteredOrders.length > 0 ? (
              filteredOrders.map((order, index) => {
                const orderStatusClass =  order.totals.status === "Pending" ? "pending" : order.totals.status === "Canceled" ? "error" : order.totals.status === "Payment Confirmed" ? "success" : '';                 
                return (
                    <div className="order--card" key={index}>
                      <div className="order--card-header">
                        <p className="orderHead orderNo">Order No.: <span>{order.totals.increment_id}</span></p>
                        <p className="orderHead orderDate">
                          Ordered Date: <span>{new Date(order.created_at).toLocaleString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          })}</span>
                        </p>
                      </div>  
                      <div className="order-item">      
                        {order.items.map((item, idx) => {
                              let additionalOptions = [];
                              try {
                                const productOptions = typeof item.product_options === 'string'
                                  ? JSON.parse(item.product_options)
                                  : item.product_options;

                                additionalOptions = productOptions?.additional_options || [];
                              } catch (err) {
                                console.error("Error reading product_options:", err);
                              }
                              const expectedDelivery = additionalOptions.find(opt => opt.label === "Expected Delivery Date")?.value || "N/A";                           
                          return (                    
                            <div className="item" key={idx}>
                              <div className="order--card-body">
                                <div className="productList">
                                  <div className="product--thumbnail">
                                    <img src={item.image_url} alt={item.title} className="product--thumbnail-img" />
                                  </div>
                                  <div className="product-details">
                                      <p className="productStatus orderHead">Product Name:
                                        <span className="product-name"> {item.title}</span>
                                      </p>
                                    <p className="productStatus orderHead">
                                      Status: <span className={`orderStatus ${orderStatusClass}`}>{order.totals.status}</span>
                                    </p>
                                    <p className="productStatus orderHead expected">
                                      Expected on: <span className="expectedDate">{expectedDelivery}</span>
                                    </p>
                                    <div className="QP">
                                      <p className="productQuantity orderHead">Quantity:
                                        <span className="productQuantity-count">1</span>
                                      </p>
                                      <p className="productPrice ">&#8377; {Math.round(item.price)}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>                        
                              <div className={`order--card-footer ${order.items.length > 1 ? "border_bottom" : ''}`}>
                                <div className="order--btn-group">
                                  <div className="order--btn orderDetails">
                                    <span onClick={()=>viewOrderDetails(item.item_id)}>View Details</span>
                                  </div>
                                    {!decodedOrderItemIds.includes(item.item_id) && item?.can_return &&  (                                                                         
                                      <div className="order--btn orderReturn" onClick={()=>handleReturnOrder(item.item_id, order.totals.entity_id)} data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return product</span>
                                      </div>
                                    )}
                                    {tempReturn=="PENDING" &&  (                                                                         
                                      <div className="order--btn orderReturn" data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return Request Initiated</span>
                                      </div>
                                    )}
                                    {item?.rma_status == "pending" &&  (                                                                         
                                      <div className="order--btn orderReturn" data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return Request Initiated</span>
                                      </div>
                                    )}
                                    {item?.rma_status == "authorized" &&  (                                                                         
                                      <div className="order--btn orderReturn" data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return Request Authorized</span>
                                      </div>
                                    )}
                                    {item?.rma_status == "approved" &&  (                                                                         
                                      <div className="order--btn orderReturn" data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return Request Approved</span>
                                      </div>
                                    )}
                                    {item?.rma_status == "received" &&  (                                                                         
                                      <div className="order--btn orderReturn" data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return Request Received</span>
                                      </div>
                                    )}
                                    {item?.rma_status == "processed_closed" &&  (                                                                         
                                      <div className="order--btn orderReturn" data-item={item.item_id} data-order={order.totals.entity_id}>
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.46412 1.6665C7.48859 1.6665 5.69738 2.38637 4.29105 3.57499L2.75087 2.55378C2.66717 4.17766 2.58346 5.73458 2.49976 7.35847C3.93949 6.62186 5.329 5.90199 6.75199 5.18213L5.39596 4.29485C6.53444 3.42432 7.9406 2.92208 9.48078 2.92208C13.2308 2.92208 16.2777 6.00244 16.2777 9.78592C16.2777 13.5693 13.2308 16.6498 9.48078 16.6498C7.73971 16.6498 6.16605 15.9968 4.96069 14.9086C4.69292 15.2268 4.40824 15.528 4.10698 15.8127C5.51323 17.0849 7.40489 17.8719 9.46412 17.8719C13.8838 17.8719 17.4998 14.239 17.4998 9.76918C17.4998 5.29932 13.9004 1.6665 9.46412 1.6665ZM5.84797 12.6989L9.51426 14.8082V10.489L5.84797 8.37967V12.6989ZM5.96516 8.229L9.63154 10.3384L10.8201 8.76472L7.15377 6.6386L5.96516 8.229ZM7.92386 6.20333L11.5902 8.29597L13.1806 8.21226L9.51426 6.10289L7.92386 6.20333ZM9.76538 14.8082L13.4317 12.6989V8.37967L9.76538 10.489V14.8082Z" fill="#6E7191"></path>
                                          </svg>       
                                          <span>Return Request Closed</span>
                                      </div>
                                    )}
                                    {item?.candere_360_invoice_file_path && (
                                      <div className="order--btn orderInvoice">
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g clipPath="url(#clip0_1872_933)">
                                          <path d="M11.6847 6H10.6247V2.66667C10.6247 2.3 10.3247 2 9.95801 2H7.29134C6.92467 2 6.62467 2.3 6.62467 2.66667V6H5.56467C4.97134 6 4.67134 6.72 5.09134 7.14L8.15134 10.2C8.41134 10.46 8.83134 10.46 9.09134 10.2L12.1513 7.14C12.5713 6.72 12.278 6 11.6847 6ZM3.95801 12.6667C3.95801 13.0333 4.25801 13.3333 4.62467 13.3333H12.6247C12.9913 13.3333 13.2913 13.0333 13.2913 12.6667C13.2913 12.3 12.9913 12 12.6247 12H4.62467C4.25801 12 3.95801 12.3 3.95801 12.6667Z" fill="#6E7191"/>
                                          </g>
                                          <defs>
                                          <clipPath id="clip0_1872_933">
                                          <rect width="16" height="16" fill="white" transform="translate(0.625)"/>
                                          </clipPath>
                                          </defs>
                                        </svg>             
                                        <a href={item?.candere_360_invoice_file_path} download target='_blank'>Order Invoice</a>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                )
              })
            ) : (
                  <div className="order--empty">
                    <img src={empty} alt="Empty Order Details" />
                    <p className="order--empty-head">You have no {activeTab == 1 ? "Open" : activeTab == 2 ? "Cancled" : activeTab == 3 ? "Completed" : ''  } Order</p>
                  </div>
                )
          ) : (
                <div className="order--empty">
                  <img src={empty} alt="Empty Order Details" />
                  <p className="order--empty-head">Oh no! You haven't placed any order yet!</p>
                  <p className="order--empty-body">
                    Start shopping and order Jewellery for you & your loved ones
                  </p>
                  <div className="order--empty-btnWrapper">
                    <Link to="/" className="order--empty-btn">Explore Designs</Link>
                  </div>
                </div>
              )
        }
      </div>

     
      
      

      <BottomSheet
        open={isSheetId === "returnOrderSheet" && isSheetOpen}
        onDismiss={() => dispatch(sheetClose())}
        defaultSnap={({ snapPoints, lastSnap }) => lastSnap ?? Math.min(...snapPoints)}
        header={
          <div className="sheetHeader">
            <SectionTitle title="Return Item" />
            <div className="sheetHeader--close" onClick={() => dispatch(sheetClose())}>
              <img src={close} alt="BottomSheet Close" className="img-fluid" />
            </div>
          </div>
        }
      >
        <div className="sheetBody">
        <form className="sheetBody--form" onSubmit={(e) => e.preventDefault()}>
            <div className="input_group_container">
              <div className="custome_select">
                   <select className="type_select" defaultValue="" onChange={handleReasonChange}>
                    <option value="" disabled>
                      Select reason for return?
                    </option>
                    {returnDataValue?.values.map((reason) => (
                      <option key={reason.option_id} value={reason.option_id}>
                        {reason.label}
                      </option>
                    ))}
                  </select>

                  <div className="label_ pushedUp">Why are you returning this product?</div>
              </div>
            </div>
            { !isBuyback &&
              <div className="input_group_container">
                <div className="custome_select">
                    <select className="type_select" defaultValue="" onChange={handleReasonChangeValue}>
                      <option value="" disabled>
                        Select Reason Details?
                      </option>
                      {detailOptions.map((item) => (
                        <option key={item.option_id} value={item.option_id}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <div className="label_ pushedUp">Detailed reason for return</div>
                </div>
              </div>
            }
            <div className="base_btn btn_lg primary_btn" onClick={()=>submitReturnRequest()}>
              Submit
            </div>
          </form>
        </div>
      </BottomSheet>

      <BottomSheet
        open={isSheetId === "viewOrderDetails" && isSheetOpen}
        onDismiss={() => dispatch(sheetClose())}
        defaultSnap={({ snapPoints, lastSnap }) => lastSnap ?? Math.min(...snapPoints)}
        header={
          <div className="sheetHeader">
            <SectionTitle title="Order Details" />
            <div className="sheetHeader--close" onClick={() => dispatch(sheetClose())}>
              <img src={close} alt="BottomSheet Close" className="img-fluid" />
            </div>
          </div>
        }
      >
        <div className="sheetBody">
          {viewItem && viewItem.product_options && (
            <>
              <div className="filter--card">
                <div className="filter--card-image">
                  <img src={viewItem.image_url} alt={viewItem.title} className="img-fluid" />
                </div>
                <div className="filter--card--data">
                  <p className="filter--card--data-name">{viewItem.title}</p>
                  <div className="filter--card--data-price">
                    <p className="filter--card--data-price-new">&#8377;{parseInt(viewItem.price)}</p>
                  </div>
                </div>
              </div>

              <div className="filter--details">
                <div className="filter--details--item">
                  <p className="filter--details--item-text">Metal Color /Purity</p>
                  <p className="filter--details--item-data">
                    {viewItem.product_options.info_buyRequest?.metal} / {viewItem.product_options.info_buyRequest?.purity}
                  </p>
                </div>
                <div className="filter--details--item">
                  <p className="filter--details--item-text">Metal Weight (Approx.)</p>
                  <p className="filter--details--item-data">{viewItem.product_options.info_buyRequest?.metal_weight}g</p>
                </div>
                <div className="filter--details--item">
                  <p className="filter--details--item-text">Diamond Clarity/Color</p>
                  <p className="filter--details--item-data">{viewItem.product_options.info_buyRequest?.clarity}</p>
                </div>
                <div className="filter--details--item">
                  <p className="filter--details--item-text">Diamond Weight</p>
                  <p className="filter--details--item-data">{viewItem.product_options.info_buyRequest?.stone_details}</p>
                </div>
                <div className="filter--details--item">
                  <p className="filter--details--item-text">Making Charges</p>
                  <p className="filter--details--item-data">&#8377;{viewItem.product_options.making_charge}/-</p>
                </div>
              </div>
            </>
          )}
        </div>        
      </BottomSheet>


    </>
  )
}

export default OrderDetails